import React, { createContext, useState, useContext } from 'react';
import { RegisterInterface } from '../models/Register';

interface RegisterContextProps {
    registerInfo: RegisterInterface;
    setRegisterInfo: React.Dispatch<React.SetStateAction<RegisterInterface>>;
    googleAddress: any;
    setGoogleAddress: React.Dispatch<React.SetStateAction<any>>;
    isAccessibilitySet: boolean;
    setIsAccessibilitySet: React.Dispatch<React.SetStateAction<boolean>>;

}

const RegisterContext = createContext<RegisterContextProps | undefined>(undefined);

type RegisterProviderProps = {
    children: React.ReactNode;
};

const RegisterProvider: React.FC<RegisterProviderProps> = ({ children }) => {
    const [registerInfo, setRegisterInfo] = useState<RegisterInterface>({
        user: {
            email: "",
            password: "",
            dateOfBirth: "",
            phoneNumber: "",
            emailPreferences: "AustraliaWide",
            accessibility: null,
            otherAccessibility: null
        },
        address: {
            latitude: null,
            longitude: null,
            longLocation: null,
            shortLocation: null,
            detailsJson: "",
            country: "",
            unitOrApartmentNumber: null,
            street: "",
            suburb: null,
            state: null,
            postCode: ""
        },
        phoneNumberVerificationCode: ""
    } as RegisterInterface);

    const [googleAddress, setGoogleAddress] = React.useState<any>(null);
    const [isAccessibilitySet, setIsAccessibilitySet] = React.useState<boolean>(false);

    return (
        <RegisterContext.Provider value={{ 
            registerInfo, setRegisterInfo, 
            googleAddress, setGoogleAddress,
            isAccessibilitySet, setIsAccessibilitySet }}>
            {children}
        </RegisterContext.Provider>
    );
};

const useRegisterContext = () => {
    const context = useContext(RegisterContext);
    if (context === undefined) {
        throw new Error('useRegisterContext must be used within RegisterProvider');
    }
    return context;
};

export { RegisterProvider, useRegisterContext };